import Joi from 'joi';

export const seekerLeadFormSchema = Joi.object({
  operationType: Joi.object().required().messages({
    'object.empty': 'Operation type is required',
    'any.required': 'Operation type is required',
  }),
  unitType: Joi.array().min(1).required().messages({
    'array.base': 'Unit type is required',
    'array.min': 'Unit type is required',
    'any.required': 'Unit type is required',
  }),
  country: Joi.object().required().messages({
    'object.base': 'Country is required',
    'object.empty': 'Country is required',
    'any.required': 'Country is required',
  }),
  city: Joi.object().required().messages({
    'object.base': 'City is required',
    'object.empty': 'City is required',
    'any.required': 'City is required',
  }),
  bedrooms: Joi.array().min(1).required().messages({
    'array.base': 'Bedrooms is required',
    'array.min': 'Bedrooms is required',
    'any.required': 'Bedrooms is required',
  }),
  bathrooms: Joi.array().min(1).required().messages({
    'array.base': 'Bathrooms is required',
    'array.min': 'Bathrooms is required',
    'any.required': 'Bathrooms is required',
  }),
  extraNotes: Joi.string().allow(''),
});
